import { render } from "./editor-layout.vue?vue&type=template&id=1bb9add4"
import script from "./editor-layout.vue?vue&type=script&lang=ts"
export * from "./editor-layout.vue?vue&type=script&lang=ts"
script.render = render

export default script